import React from "react";
import FormGroup from "../components/fields/FormGroup";
import RadioButtonGroup from "../components/fields/RadioButtonGroup";
import Select from "../components/fields/Select";
import cn from "classnames";
export { struct } from "tcomb-form-templates-bootstrap";

function getButton(config, key) {
  return (
    <button key={key} className="btn" onClick={config.click}>
      {config.label}
    </button>
  );
}

export function textbox(locals) {
  const type = locals.attrs.type || "text";
  const { className, ...attrs } = locals.attrs;

  if (type === "textarea") {
    return (
      <FormGroup locals={locals}>
        <textarea
          {...attrs}
          className={cn("form-control", className)}
          value={locals.value}
          onChange={e => locals.onChange(e.target.value)}
        />
      </FormGroup>
    );
  } else {
    return (
      <FormGroup locals={locals}>
        <input
          {...attrs}
          type={type}
          className={cn("form-control", className)}
          value={locals.value}
          onChange={e => locals.onChange(e.target.value)}
        />
      </FormGroup>
    );
  }
}

export function checkbox(locals) {
  return (
    <FormGroup locals={locals}>
      <input
        type="checkbox"
        checked={locals.value}
        onChange={e => locals.onChange(e.target.checked)}
      />
    </FormGroup>
  );
}

export function select(locals) {
  return (
    <FormGroup locals={locals}>
      <Select
        options={locals.options}
        onChange={locals.onChange}
        value={locals.value}
      />
    </FormGroup>
  );
}

export function radio(locals) {
  return (
    <FormGroup locals={locals}>
      <RadioButtonGroup
        options={locals.options}
        onChange={locals.onChange}
        value={locals.value}
      />
    </FormGroup>
  );
}

export function date(locals) {
  return (
    <FormGroup locals={locals}>
      <input
        type="date"
        value={locals.value}
        onChange={e => locals.onChange(e.target.value)}
      />
    </FormGroup>
  );
}

export function list(locals) {
  let children = [];

  children = children.concat(
    locals.items.map(item => {
      return (
        <div className="list-item" key={item.key}>
          {item.input}
          <div className="list-item-buttons">
            {item.buttons.map((button, i) => {
              return getButton(button, i);
            })}
          </div>
        </div>
      );
    })
  );

  if (locals.add) {
    children.push(getButton(locals.add, "add"));
  }

  return (
    <FormGroup className="form-list" locals={locals}>
      {children}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./app/lib/fieldTemplates.js